<template>
  <v-app id="materialpro" :class="`${!$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'}`">
     <v-progress-circular
      v-if='$root.loading'
      size='20'
      color="#0A9C99"
      indeterminate
    ></v-progress-circular>
      <router-view />
  </v-app>
</template>
<script>
export default {
  name: 'App',
  async mounted(){
      await this.$store.dispatch("getOnDemandStatus")
      let programs = this.$database.ref("01CNvKma7Ziku8l3RwGsKZvMd4heja-b5hV90WnmPgkNY/Programs");
      await programs.on("value",this.programsData,this.fail);
      let lgas = this.$database.ref("01CNvKma7Ziku8l3RwGsKZvMd4heja-b5hV90WnmPgkNY/LGAs");
      await lgas.on("value",this.lgaData,this.fail);
      let submi = this.$database.ref("01CNvKma7Ziku8l3RwGsKZvMd4heja-b5hV90WnmPgkNY/Submissions");
      await submi.on("value",this.submData,this.fail);
      this.$root.loading = false
  },
  methods:{
  async programsData(data){
      data = data.val()
      this.$store.dispatch('updatePrograms', data)
  },
  async submData(data){
      data = data.val()
      this.$store.dispatch('updateSubm', data)
  },
  async lgaData(data) {
      data = data.val();
      await this.$store.dispatch('updatesLGAs', data)
    },
  async formatData() {
  this.$root.loading = false;
  return
  },


  fail(err){
  console.log(err)
  }
  },
};
</script>
<style scoped>
.v-progress-circular {
    margin: 1rem;
    position: fixed;
    z-index: 1000000;
    width: 100% !important;
    height: 100vh !important;
    background: black;
    opacity: 0.5;
}
</style>